import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Input from "../../components/Input";
import PasswordInput from "../../components/PasswordInput";
import Button from "../../components/Button";
import ScreenContainer from "../../components/ScreenContainer";
import Header from "../../components/Header";
import Note from "../../components/Note";
import { updatePassword, verifyToken } from "../../services/auth";
import Error from "../../components/Error";
import { t } from "i18next";
import { isTesting } from "../../utils/Generic";

const Registration = () => {
  const navigate = useNavigate();
  const { state, pathname, search } = useLocation()
  
  const [email, setEmail] = useState(isTesting() ? "test@email.com" : state.email);
  const [pwd, setPwd] = useState("");
  const [checkPwd, setCheckPwd] = useState("");
  const [isPwdValid, setPwdValid] = useState(false);
  const [isCheckPwdValid, setCheckPwdValid] = useState(false);
  const [error, setError] = useState("")
  const [isLoading, setLoading] = useState(false)

  const isDataValid = isPwdValid && isCheckPwdValid && pwd === checkPwd;
 
  function handleEmailChange(email, isValid) {
    setEmail(email);
  }

  function handlePwdChange(pwd, isValid) {
    setPwd(pwd);
    setPwdValid(isValid);
  }

  function handleCheckPwdChange(pwd, isValid) {
    setCheckPwd(pwd);
    setCheckPwdValid(isValid);
  }

  const handleConfirm = () => {
    sessionStorage.setItem('email', email);
    
    setLoading(true)
    updatePassword(email, pwd)
      .then(() => {
        //navigate('/agreements');
        navigate('/registration_complete')
      })
      .catch((error) => {
        setError(trans(25))
      })
      .finally(() => setLoading(false))
  };

  useEffect(() => {
    
    if (!email) navigate("/error")
  }, [])

  function trans(key){
    return t("onb-web_inputpassword_"+key)
  }

  return (
    <ScreenContainer>
      <Header withBackButton={false} />
      <div className={"scrollContainer"} style={{ minHeight: "calc(100dvh - 54px)" }}>

        <h1 className={"title title_m_24_medium"}>{trans(16)}</h1>
        <p className={"description body_15_regular mt-16"}>
          {trans(17)}
        </p>

        <div className={"form"}>
          <label className="label body_14_regular">{trans(18)}</label>
          <Input
            placeholder={trans(18)}
            value={email}
            onChangeText={handleEmailChange}
            type="email"
            readOnly={true}
          />
          <label className="label body_14_regular mt-24">{trans(19)}</label>
          <PasswordInput
            placeholder={trans(20)}
            value={pwd}
            onChangeText={handlePwdChange}
          />
          <div className="mt-8" />
          <PasswordInput
            placeholder={trans(21)}
            value={checkPwd}
            onChangeText={handleCheckPwdChange}
          />
          <Note className={"mt-16"}>
            {trans(22)}
          </Note>
          {error ? <Error className={"mt-16"}>
            {error}
          </Error> : null}
        </div>

        <Button
          text="Continue"
          onClick={handleConfirm}
          disabled={!isDataValid}
          primary={isDataValid}
          className={(isDataValid ? "primary-on-button" : "primary-off-button") + " primary-button-text"}

        />
      </div>
    </ScreenContainer>
  );
};

export default Registration;
